import { render, staticRenderFns } from "./PacketsView.vue?vue&type=template&id=e4bb9d34"
import script from "./PacketsView.vue?vue&type=script&lang=ts"
export * from "./PacketsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports